import { render, staticRenderFns } from "./RecursosGrupoUsuario.vue?vue&type=template&id=64d7790a&scoped=true"
import script from "./RecursosGrupoUsuario.vue?vue&type=script&lang=js"
export * from "./RecursosGrupoUsuario.vue?vue&type=script&lang=js"
import style0 from "./RecursosGrupoUsuario.vue?vue&type=style&index=0&id=64d7790a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7790a",
  null
  
)

export default component.exports